<hr>
<div style="margin-top: 32px;margin-bottom: 32px;text-align: center;">
  <h1>Accesso Sicuro</h1>
  <p>Scansiona il QR Code per accedere</p>
  <div>
    <canvas #qrCanvas></canvas>
  </div>
  <a id="link-qrcode" href="#" #qrLink>Clicca qui per accedere</a>
</div>
<hr>
